import React, { Component, Fragment } from 'react'
import Helmet from 'react-helmet'

class Single extends Component {
  componentDidMount() {
    document.body.className = ''
    document.body.classList.add('page')
  }
  render() {
    const { options: {acf: {options_copyright}}, page, page: {acf: { rangees }, _embedded }, siteTitle } = this.props

    return (
      <Fragment>
        <Helmet>
          <title>{siteTitle}</title>
          <meta property="og:locale" content="fr_FR" />
          <meta property="og:title" content={siteTitle} />
          <meta property="og:site_name" content="Domaine Elisabeth" />
          <meta property="og:type" content="article" />
        </Helmet>
        <div>
          <div className="page__wrapper">
            <div className="page__body">
              <div className="container">
                <h1 className="page__title">{page.title.rendered}</h1>
                <div className="page__thumbnail">
                  <img src={_embedded['wp:featuredmedia'][0].source_url} alt={_embedded['wp:featuredmedia'][0].alt_text} />
                </div>
                {
                  rangees
                    .filter(row => row.acf_fc_layout === 'bloc_texte_simple')
                    .map((row, index) => (
                      <p key={index} dangerouslySetInnerHTML={{__html: row.texte}} />
                    ))
                }
              </div>
            </div>
            <div className="page__footer">
              <div className="container">
                <p>{options_copyright.replace('%%date%%', (new Date()).getFullYear())}</p>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default Single


// WEBPACK FOOTER //
// ./src/pages/Page.js